function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-4.000000, -1.000000)",
  fill: "#484848",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(4.000000, 1.000000)"
}, React.createElement("path", {
  d: "M7,0 C3.13345455,0 0,3.13345455 0,7 C0,9.56518182 2.34690909,12.2837273 3.20154545,14.6713636 C4.47618182,18.2318182 4.33490909,20.3636364 7,20.3636364 C9.70454545,20.3636364 9.52318182,18.242 10.7984545,14.686 C11.6556364,12.2932727 14,9.54545455 14,7 C14,3.13345455 10.8652727,0 7,0 Z M8.64945455,17.2938182 L5.49436364,17.6877273 C5.38172727,17.3619091 5.26081818,16.9807273 5.11381818,16.4830909 C5.11190909,16.4767273 5.10936364,16.4697273 5.10809091,16.4633636 L9.04590909,15.9714545 C8.98990909,16.1591818 8.93009091,16.3564545 8.87790909,16.5333636 C8.79454545,16.8190909 8.72009091,17.0672727 8.64945455,17.2938182 Z M4.92290909,15.8505455 C4.80709091,15.4674545 4.67663636,15.064 4.53154545,14.6363636 L9.47354545,14.6363636 C9.39527273,14.8648182 9.317,15.0939091 9.24954545,15.3102727 L4.92290909,15.8505455 Z M7,19.0909091 C6.35536364,19.0909091 6.05881818,19.0164545 5.72918182,18.2954545 L8.42609091,17.9575455 C8.03536364,19.0100909 7.75090909,19.0909091 7,19.0909091 Z M9.97309091,13.3636364 L4.03390909,13.3636364 C3.717,12.6763636 3.33645455,11.9890909 2.961,11.3164545 C2.13054545,9.83054545 1.27272727,8.29372727 1.27272727,7 C1.27272727,3.84172727 3.84172727,1.27272727 7,1.27272727 C10.1582727,1.27272727 12.7272727,3.84172727 12.7272727,7 C12.7272727,8.28418182 11.8681818,9.82927273 11.0370909,11.3240909 C10.6654545,11.9941818 10.2874545,12.6801818 9.97309091,13.3636364 Z"
}), React.createElement("path", {
  d: "M7,3.18181818 C4.89427273,3.18181818 3.18181818,4.89427273 3.18181818,7 C3.18181818,7.17563636 3.32436364,7.31818182 3.5,7.31818182 C3.67563636,7.31818182 3.81818182,7.17563636 3.81818182,7 C3.81818182,5.24554545 5.24554545,3.81818182 7,3.81818182 C7.17563636,3.81818182 7.31818182,3.67563636 7.31818182,3.5 C7.31818182,3.32436364 7.175,3.18181818 7,3.18181818 Z"
}))));

const SvgLightBulbIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "14px",
  height: "21px",
  viewBox: "0 0 14 21",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLightBulbIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/light-bulb-icon.92127201.svg";
export { ForwardRef as ReactComponent };